// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":host /deep/ .ps-content {\n    flex: auto;\n    display: flex;\n}\n", "",{"version":3,"sources":["webpack://./src/components/tabBody.deep.component.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,aAAa;AACjB","sourcesContent":[":host /deep/ .ps-content {\n    flex: auto;\n    display: flex;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
